import { audienceClient } from "@di-devs/audience-feature-plugin/client";
import { authClient } from "@di-devs/auth-feature-plugin/client";
import { createFeatureClient as createVanillaFeatureClient } from "@di-devs/better-feature/client";
import { createFeatureClient as createReactFeatureClient } from "@di-devs/better-feature/react";
import { eventClient } from "@di-devs/event-feature-plugin/client";
import { memberClient } from "@di-devs/member-feature-plugin/client";
import { richmenuClient } from "@di-devs/richmenu-feature-plugin/client";
import { systemSettingsClient } from "@di-devs/system-settings-feature-plugin/client";

export const vanillaFeatureClient = createVanillaFeatureClient({
	baseURL: import.meta.env.VITE_APP_API_URL ?? "http://localhost:8080",
	basePath: "/api2",
	plugins: [
		memberClient(),
		authClient(),
		systemSettingsClient(),
		richmenuClient(),
		eventClient(),
	],
	fetchOptions: {
		credentials: "include",
	},
});

/**
 * Better Feature Client Configuration
 * Initializes the Better Feature client with all enabled plugins
 */
export const reactFeatureClient = createReactFeatureClient({
	baseURL: import.meta.env.VITE_APP_API_URL ?? "http://localhost:8080",
	basePath: "/api2",
	plugins: [
		memberClient(),
		authClient(),
		systemSettingsClient(),
		richmenuClient(),
		audienceClient(),
		eventClient(),
	],
	fetchOptions: {
		credentials: "include",
	},
});

export const featureClient = reactFeatureClient;

/**
 * Type-safe client instance for use throughout the application
 */
export type FeatureClient = typeof reactFeatureClient;
